import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { em } from 'polished';
import { colors, isDefaultThemeMode } from 'core/theme';

export const StyledNav = styled.nav`
  display: flex;
  justify-content: space-between;
  margin-top: 2em;

  & > a {
      flex 0 0 50%;
      overflow-x: hidden;
      white-space: nowrap;

      & > small {
          display: block;
          overflow-x: hidden;
          text-overflow: ellipsis;
      }

      &[rel="prev"] > small {
          padding-right: 1em;
      }

      &[rel="next"] > small {
          padding-left: 1em;
      }
  }
`;

export const FlipHorizontal = styled.i`
    display: inline-block;
    transform: scaleX(-1);
`;

export const StyledLink = styled(Link)`
  color: ${colors.primary};
  padding: 0.5em;
  margin: -0.5em;
  text-decoration: none;

  &[rel="next"] {
    text-align: right;
  }

  p {
    font-size: ${em(20)};
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0.5em;

    i {
      font-size: 1rem;
      margin-top: -0.1em;
    }
  }

  small {
    color: ${colors.subtleText};
    font-size: ${em(14)};
  }

  &:hover {
    color: ${colors.primaryLight};

    ${props => !isDefaultThemeMode(props) && css`
      background-color: ${colors.text};

      &, small {
        color: ${colors.background};
      }
    `};
  }
`;

export const StyledLabel = styled.span`
    &:first-child {
      margin-right: 1em;
    }
    &:last-child {
      margin-left: 1em;
    }
`;


// WEBPACK FOOTER //
// ./src/elements/Pagination/styled.js